var T={ACTION:"ACTION",HIGHLIGHT:"HIGHLIGHT",TEXT:"TEXT"},E={LEFT:"LEFT",RIGHT:"RIGHT",CENTER:"CENTER"};export{T as DataTableCellVariants,E as DataTableColumnAlignments};
//# sourceMappingURL=types.js.map
